import { Collapse } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CollapseTransition = styled(Collapse)`
  overflow: ${({ in: isEnabled }) =>
    isEnabled ? "initial !important" : "hidden"};
`;
